<template>
  <div class="container">
    <ModalPending :visibleModalPendency="isModalPendencyVisible" @close="closeModalPendency"
                  :reportUnsigned="reportUnsigned"></ModalPending>
    <ModalTriage :visibleModalTriage="isModalTriageVisible" :protocolUpdatePopup="protocolUpdate"
                 :enableButton="Enable" @hideModalTriage="hideModalTriage"></ModalTriage>
    <div v-if="isLoading">
      <div class="container my-5">
        <div class="row mt-5">
          <div class="row mt-4">
            <div class="col-2"></div>
            <div class="col-8">
              <div class="centered-container">
                <div class="loading"></div>
              </div>
              <p class="text-font-regular" style="margin-top: 10px; text-align: center">
                Carregando...
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="container mt-5 mb-5">
        <!-- Pendencias -->
        <div v-if="ReportsUnsigned.length + ExpiredEvents.length > 0">
          <div class="row mt-5">
            <div class="col-1"></div>
            <div class="col-10">
              <h4 class="text-font">
                Pendências <span class="circle-number">{{ ReportsUnsigned.length + ExpiredEvents.length }}</span>
              </h4>
            </div>
            <div class="col-1"></div>
          </div>
          <!-- Casos vencidos (não assumidos no prazo) -->
          <div v-for="protocol in ExpiredEvents" v-bind:key="'expired-' + protocol.id">
            <div class="row mt-4">
              <div class="col-1"></div>
              <div class="col-10">
                <div class="card card-expired">
                  <div class="card-header card-header-expired">
                    <strong>
                      <i class="bi bi-hospital px-1">
                      </i>{{ protocol.protocol_info.company }}
                    </strong>
                  </div>
                  <div class="card-body">
                    <div class="card-text">
                      Especialidade:
                      <b class="text-success">{{ protocol.protocol_info.specialty }}</b>
                    </div>
                    <div class="card-text">
                      Paciente: {{ formatName(protocol.protocol_info.patient_info.name) }}
                    </div>
                    <div class="d-flex align-items-center my-2">
                      <i class="bi bi-clock"></i>
                      <strong class="px-2">{{ formatDateTime(protocol.event_slot_info.start) }}</strong>
                    </div>
                    <button class="btn btn-open-record mt-2 px-4" @click="showModalTriage(protocol)"
                            :disabled="!Enable" data-bs-toggle="modal" data-bs-target="#triageModal">
                      ABRIR PRONTUÁRIO
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-1"></div>
            </div>
          </div>
          <div v-if="ReportsUnsigned.length > 0">
            <ul style="list-style-type: none">
              <li v-for="report in ReportsUnsigned" v-bind:key="report.id">
                <div class="row mt-4">
                  <div class="col-1"></div>
                  <div class="col-10">
                    <div class="card">
                      <div class="card-body card-border-pendency">
                        <img src="../assets/alert-triangulo-red.png" alt="ic_cam"/>
                        <h4 class="card-title" style="margin-top: 5px;">
                          Você possui uma pendência
                        </h4>
                        <p class="card-text">
                          Verificamos a presença de documentos não assinados em seu histórico.
                        </p>
                        <h6 style="margin-bottom: 0; margin-top: 5px; color: #777">
                          {{ report.protocol_update_info.protocol_info.company }}
                        </h6>
                        <h6 style="margin-bottom: 0; color: #777">
                          Paciente: {{ formatName(report.protocol_update_info.protocol_info.patient_info.name) }}
                        </h6>
                        <div class="mt-4"></div>
                        <div class="d-flex justify-content-between">
                          <p></p>
                          <button class="btn btn-outline-danger" @click="showModalPendency(report)"
                                  :disabled="!Enable" data-bs-toggle="modal" data-bs-target="#pendingModal">Resolver
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-1"></div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- Meus Casos -->
        <div class="row mt-5">
          <div class="col-10">
            <div v-if="Reports.length">
              <h5 class="text-font">
                Casos em Atendimento <span class="circle-number px-2">{{ Reports.length }}</span>
              </h5>
            </div>
            <div v-else>
              <h5 class="text-font">Casos em Atendimento</h5>
            </div>
          </div>
        </div>
        <div v-if="Reports.length">
          <div>
            <div v-for="report in Reports" v-bind:key="report.id">
              <div class="row mt-4">
                <div class="col-12">
                  <div class="card">
                    <div class="card-header bg-warning-subtle">
                      <strong>
                        <i class="bi bi-hospital px-1">
                        </i>{{ report.protocol_update_info.protocol_info.company }}
                      </strong>
                    </div>
                    <div class="card-body" v-if="report.protocol_update_info.protocol_info.type.id === 3">
                      <p>
                        <b>Especialidade:</b>
                        {{ report.protocol_update_info.protocol_info.specialty }}
                      </p>
                      <p class="card-text">
                        <strong>Paciente:</strong>
                        {{
                          formatName(report.protocol_update_info.protocol_info.patient_info.name)
                        }}
                      </p>

                      <div class="d-flex">
                        <div class="px-3">
                          <i class="bi bi-clock"></i>
                          <strong class="px-1">
                            {{ new Date(report.protocol_update_info.event_slot_info.start).toLocaleString() }} (Horário
                            de Brasília)
                          </strong>
                        </div>
                      </div>
                      <button class="btn btn-primary me-2 mt-2 px-3" @click="openAttendanceFormInfo(report)">Abrir
                        prontuário
                      </button>
                      <a class="btn btn-primary me-2 mt-2 px-3" :href="report.protocol_update_info.event_slot_info.url"
                         target="_blank">Entrar na vídeo consulta
                      </a>
                    </div>
                    <div class="card-body" v-else>
                      <p>
                        <b>Hora de início:</b>
                        {{ report.protocol_update_info.created_at }}
                      </p>
                      <p class="card-text">
                        <strong>Solicitante:</strong>
                        {{
                          formatName(report.protocol_update_info.nurse ? report.protocol_update_info.nurse_info.name : report.protocol_update_info.responsible_info.name)
                        }}
                      </p>

                      <div class="col-8 my-2" v-if="report.protocol_update_info.protocol_update_traces.length > 0">
                        <div class="accordion" id="accordionTraces">
                          <div class="accordion-item">
                            <h2 class="accordion-header">
                              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                      data-bs-target="#collapseOne"
                                      aria-expanded="true" aria-controls="collapseOne">
                                Histórico de atendimento:
                              </button>
                            </h2>
                            <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionTraces">
                              <div class="accordion-body">
                                <div class="mt-2 text-start">
                                  <div v-for="trace in report.protocol_update_info.protocol_update_traces"
                                       v-bind:key="trace.created_at">
                                    <div>
                                      <p style="margin-bottom: 0;"><b>Evento:</b> Dr. {{ trace.specialist_name }}
                                        {{ trace.description }} - {{ trace.created_at }}</p>
                                      <div v-if="trace.reason != null">
                                        <p style="margin-bottom: 0;"><b>Motivo:</b> {{ trace.reason }}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                      <div class="d-flex">
                        <div class="text-warning px-3">
                          <i class="bi bi-clock"></i>
                          <strong class="px-1">{{ diffTime(report.protocol_update_info.created_at) }}</strong>
                        </div>
                        <div class="text-danger px-3" v-if="report.protocol_update_info.AVC_protocol === 1">
                          <i class="bi bi-exclamation-triangle"></i>
                          <strong class="px-1">AVC</strong>
                        </div>
                        <div class="text-success px-3" v-if="report.protocol_update_info.unread_messages > 0">
                          <i class="bi bi-chat-square-text"></i>
                          <strong class="px-1">{{ report.protocol_update_info.unread_messages }}
                            msg{{ report.protocol_update_info.unread_messages !== 1 ? "s" : "" }}</strong>
                        </div>
                      </div>
                      <button class="btn btn-primary my-2 px-3" @click="openAttendanceFormInfo(report)">Atender
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="row mt-4">
            <div class="col-12">
              <h3 class="text-font-regular text-center">
                <i class="bi bi-folder2-open"></i>
              </h3>
              <p class="text-font-regular text-center">
                Não há casos ativos em antendimento.
              </p>
            </div>
          </div>
        </div>

        <!-- Em Fila -->
        <ul class="nav nav-tabs pt-3" id="queueTab" role="tablist">
          <li class="nav-item" role="presentation"
              v-if="User.specialist.specialties_info.some(specialty => specialty.type.id === 1)">
            <button class="nav-link" id="ti-tab" data-bs-toggle="tab" data-bs-target="#ti-tab-pane" type="button"
                    role="tab" aria-controls="ti-tab-pane" aria-selected="true" v-if="User.specialist.specialties_info.some(specialty => specialty.type.id === 1)"
                    :class="{'active': User.specialist.specialties_info.some(specialty => specialty.type.id === 1)}">Teleinterconsulta
              <span class="badge bg-danger" title="Números de casos na fila">{{TIProtocols.length}}</span>
            </button>
          </li>
          <li class="nav-item" role="presentation"
              v-if="User.specialist.specialties_info.some(specialty => specialty.type.id === 2)">
            <button class="nav-link" id="rd-tab" data-bs-toggle="tab" data-bs-target="#rd-tab-pane" type="button"
                    role="tab" aria-controls="rd-tab-pane" aria-selected="true" v-if="User.specialist.specialties_info.some(specialty => specialty.type.id === 2)"
                    :class="{'active': !User.specialist.specialties_info.some(specialty => specialty.type.id === 1)}">Round Diário
              <span class="badge bg-danger" title="Números de casos na fila">{{RDProtocols.length}}</span>
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="ot-tab" data-bs-toggle="tab" data-bs-target="#ot-tab-pane" type="button"
                    role="tab" aria-controls="ot-tab-pane" aria-selected="false"
                    v-if="User.specialist.specialties_info.some(specialty => specialty.type.id === 3)"
                    :class="{'active': !User.specialist.specialties_info.some(specialty => specialty.type.id === 1 || specialty.type.id === 2)}">Ambulatorial
              <span class="badge bg-danger" title="Números de casos na fila">{{Events.length}}</span>
            </button>
          </li>
        </ul>
        <div class="tab-content" id="queueTabContent">
          <div class="tab-pane fade" id="ti-tab-pane" role="tabpanel" aria-labelledby="ti-tab" tabindex="0"
               v-if="User.specialist.specialties_info.some(specialty => specialty.type.id === 1)"
               :class="{'show active': User.specialist.specialties_info.some(specialty => specialty.type.id === 1)}">
            <div id="protocol_ti_queue">
              <div v-if="TIProtocols.length">
                <div style="list-style-type: none">
                  <div v-for="protocol in TIProtocols" v-bind:key="protocol.id">
                    <div class="row mt-4">
                      <div class="col-12">
                        <div class="card">
                          <div class="card-header bg-success-subtle">
                            <strong>
                              <i class="bi bi-hospital px-1">
                              </i>{{ protocol.protocol_info.company }}
                            </strong>
                          </div>
                          <div class="card-body">
                            <p><b>Hora de início:</b> {{ protocol.created_at }}</p>
                            <div v-if="protocol.protocol_update_traces.length > 0">
                              <div v-for="trace in protocol.protocol_update_traces" v-bind:key="trace.created_at">
                                <div>
                                  <p style="margin-bottom: 0;"><b>Evento:</b> Dr. {{ trace.specialist_name }} {{
                                      trace.description
                                    }} - {{
                                      trace.created_at
                                    }}</p>
                                  <div v-if="trace.reason != null">
                                    <p style="margin-bottom: 0;"><b>Motivo:</b> {{ trace.reason }}</p>
                                  </div>
                                </div>
                                <p></p>
                              </div>
                            </div>
                            <div class="card-text">
                              <strong>Especialidade: </strong>
                              <b :class="{
                              'specialist-type-one': protocol.protocol_info.type.id === 1,
                              'specialist-type-three': protocol.protocol_info.type.id === 3
                           }">
                                {{ protocol.protocol_info.specialty }}
                              </b>
                            </div>
                            <div class="card-text"><strong>Responsável:</strong>
                              {{ formatName(protocol.responsible_info.name) }}
                            </div>
                            <div class="card-text"><strong>Paciente:</strong>
                              {{ formatName(protocol.protocol_info.patient_info.name) }}
                            </div>
                            <div class="card-text"><strong>Tipo de caso:</strong> {{ protocol.case_type }}</div>
                            <div class="card-text"><strong>Prioridade:</strong> {{ protocol.case_priority }}</div>
                            <div class="d-flex">
                              <div class="text-warning p-3">
                                <i class="bi bi-clock"></i>
                                <strong class="px-1">{{ diffTime(protocol.created_at) }}</strong>
                              </div>
                              <div class="text-danger p-3" v-if="protocol.AVC_protocol === 1">
                                <i class="bi bi-exclamation-triangle"></i>
                                <strong class="px-1">AVC</strong>
                              </div>
                            </div>
                            <button class="btn btn-primary my-2 px-3" @click="showModalTriage(protocol)"
                                    data-bs-toggle="modal" data-bs-target="#triageModal">
                              Ver caso
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="row mt-4">
                  <div class="col-12">
                    <h3 class="text-font-regular text-center">
                      <i class="bi bi-folder2-open"></i>
                    </h3>
                    <p class="text-font-regular text-center">
                      Não há casos ativos em espera.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="rd-tab-pane" role="tabpanel" aria-labelledby="rd-tab" tabindex="0"
               v-if="User.specialist.specialties_info.some(specialty => specialty.type.id === 2)"
               :class="{'show active': !User.specialist.specialties_info.some(specialty => specialty.type.id === 1)}">
            <div id="protocol_rd_queue">
              <div v-if="RDProtocols.length">
                <div style="list-style-type: none">
                  <div v-for="protocol in RDProtocols" v-bind:key="protocol.id">
                    <div class="row mt-4">
                      <div class="col-12">
                        <div class="card">
                          <div class="card-header bg-success-subtle">
                            <strong>
                              <i class="bi bi-hospital px-1">
                              </i>{{ protocol.protocol_info.company }}
                            </strong>
                          </div>
                          <div class="card-body">
                            <p><b>Hora de início:</b> {{ protocol.created_at }}</p>
                            <div v-if="protocol.protocol_update_traces.length > 0">
                              <div v-for="trace in protocol.protocol_update_traces" v-bind:key="trace.created_at">
                                <div>
                                  <p style="margin-bottom: 0;"><b>Evento:</b> Dr. {{ trace.specialist_name }} {{
                                      trace.description
                                    }} - {{
                                      trace.created_at
                                    }}</p>
                                  <div v-if="trace.reason != null">
                                    <p style="margin-bottom: 0;"><b>Motivo:</b> {{ trace.reason }}</p>
                                  </div>
                                </div>
                                <p></p>
                              </div>
                            </div>
                            <div class="card-text">
                              <strong>Especialidade: </strong>
                              <b :class="{
                              'specialist-type-one': protocol.protocol_info.type.id === 1,
                              'specialist-type-two': protocol.protocol_info.type.id === 2,
                              'specialist-type-three': protocol.protocol_info.type.id === 3
                           }">
                                {{ protocol.protocol_info.specialty }}
                              </b>
                            </div>
                            <div class="card-text"><strong>Responsável:</strong>
                              {{ formatName(protocol.responsible_info.name) }}
                            </div>
                            <div class="card-text"><strong>Paciente:</strong>
                              {{ formatName(protocol.protocol_info.patient_info.name) }}
                            </div>
                            <div class="card-text"><strong>Tipo de caso:</strong> {{ protocol.case_type }}</div>
                            <div class="card-text"><strong>Prioridade:</strong> {{ protocol.case_priority }}</div>
                            <div class="d-flex">
                              <div class="text-warning p-3">
                                <i class="bi bi-clock"></i>
                                <strong class="px-1">{{ diffTime(protocol.created_at) }}</strong>
                              </div>
                              <div class="text-danger p-3" v-if="protocol.AVC_protocol === 1">
                                <i class="bi bi-exclamation-triangle"></i>
                                <strong class="px-1">AVC</strong>
                              </div>
                            </div>
                            <button class="btn btn-primary my-2 px-3" @click="showModalTriage(protocol)"
                                    data-bs-toggle="modal" data-bs-target="#triageModal">
                              Ver caso
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="row mt-4">
                  <div class="col-12">
                    <h3 class="text-font-regular text-center">
                      <i class="bi bi-folder2-open"></i>
                    </h3>
                    <p class="text-font-regular text-center">
                      Não há casos ativos em espera.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="ot-tab-pane" role="tabpanel" aria-labelledby="ot-tab" tabindex="0"
               v-if="User.specialist.specialties_info.some(specialty => specialty.type.id === 3)"
               :class="{'show active': !User.specialist.specialties_info.some(specialty => specialty.type.id === 1 || specialty.type.id === 2)}">
            <h5 class="fw-bold p-2">MINHA AGENDA</h5>
            <div class="container text-center">
              <div class="row">
                <div class="col-lg-6 offset-lg-3 col-xl-4 offset-xl-4">
                  <div class="row align-items-center py-3">
                    <div class="col">
                      <i class="bi bi-caret-left-fill px-2 text-primary" @click="changeDay('dec')"
                         :class="[this.loadingEvents || this.chosenDay === new Date().toISOString().slice(0, 10) ? 'text-secondary' : 'text-primary']"></i>
                    </div>
                    <div class="col fw-bold">
                      {{ weekDayNames[new Date(chosenDay).getDay()] }},
                    </div>
                    <div class="col">
                      <input type="date" class="form-control" v-model="chosenDay" :min="this.today"
                             :disabled="loadingEvents"/>
                    </div>
                    <div class="col"><i class="bi bi-caret-right-fill px-2" @click="changeDay('inc')"
                                        :class="[this.loadingEvents ? 'text-secondary' : 'text-primary']"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="Events && Events.length > 0">
              <div style="list-style-type: none">
                <div v-for="protocol in Events" v-bind:key="protocol.id">
                  <div class="row mt-4">
                    <div class="col-12">
                      <div class="card">
                        <div class="card-header bg-success-subtle">
                          <strong>
                            <i class="bi bi-hospital px-1">
                            </i>{{ protocol.protocol_info.company }}
                          </strong>
                        </div>
                        <div class="card-body">
                          <p><b>Data de criação:</b> {{ protocol.created_at }}</p>
                          <div v-if="protocol.protocol_update_traces.length > 0">
                            <div v-for="trace in protocol.protocol_update_traces" v-bind:key="trace.created_at">
                              <div>
                                <p style="margin-bottom: 0;"><b>Evento:</b> Dr. {{ trace.specialist_name }} {{
                                    trace.description
                                  }} - {{
                                    trace.created_at
                                  }}</p>
                                <div v-if="trace.reason != null">
                                  <p style="margin-bottom: 0;"><b>Motivo:</b> {{ trace.reason }}</p>
                                </div>
                              </div>
                              <p></p>
                            </div>
                          </div>
                          <div class="card-text">
                            <strong>Especialidade: </strong>
                            <b class="text-success">
                              {{ protocol.protocol_info.specialty }}
                            </b>
                          </div>
                          <div class="card-text"><strong>Responsável:</strong>
                            {{ formatName(protocol.responsible_info.name) }}
                          </div>
                          <div class="card-text"><strong>Paciente:</strong>
                            {{ formatName(protocol.protocol_info.patient_info.name) }}
                          </div>
                          <div class="d-flex">
                            <div class="p-3">
                              <i class="bi bi-clock"></i>
                              <strong class="px-1">
                                {{ new Date(protocol.event_slot_info.start).toLocaleString() }} (Horário de Brasília)
                              </strong>
                            </div>
                          </div>
                          <button class="btn btn-primary my-2 px-3" @click="showModalTriage(protocol)"
                                  data-bs-toggle="modal" data-bs-target="#triageModal">
                            Ver caso
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="row mt-4">
                <div class="col-12">
                  <h3 class="text-font-regular text-center">
                    <i class="bi bi-folder2-open"></i>
                  </h3>
                  <p class="text-font-regular text-center">
                    Não há casos ativos em espera.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" style="margin-bottom: 100px;">
    <div class="col-2"></div>
    <div class="col-8">
      <div class="attentive-buttons">
        <button class="btn-back-queue" @click="reloadPage()">Atualizar</button>
      </div>
    </div>
    <div class="col-2"></div>
  </div>
</template>


<script>
import ModalTriage from "../components/ModalTriage.vue";
import ModalPending from "../components/ModalPending.vue";
import {mapGetters, mapActions} from "vuex";
import {useGoogleAnalytics} from '@/store/analytics';

const {gTrackUpdatePageBtn} = useGoogleAnalytics();

export default {
  name: `Protocols`,
  components: {
    ModalTriage,
    ModalPending
  },
  data() {
    return {
      isLoading: true,
      isModalPendencyVisible: false,
      isModalTriageVisible: false,
      reportUnsigned: Object,
      protocolUpdate: Object,
      isFocused: false,
      hasTIProtocols: false,
      hasRDProtocols: false,
      showEvents: false,
      today: new Date().toISOString().slice(0, 10),
      chosenDay: new Date().toISOString().slice(0, 10),
      weekDayNames: ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'],
      loadingEvents: true,
    };
  },
  async created() {
    if (!this.isAuthenticated()) {
      this.$router.push("/login");
    } else {
      try {
        if (this.User.specialist.specialties_info.some(specialty => specialty.type.id === 1)) {
          await this.GetProtocols({
            specialty_type_id: 1
          })
        }
        if (this.User.specialist.specialties_info.some(specialty => specialty.type.id === 2)) {
          await this.GetProtocols({
            specialty_type_id: 2
          })
        }
        if (this.User.specialist.specialties_info.some(specialty => specialty.type.id === 3)) {
          this.showEvents = true
          this.loadingEvents = true
          await this.GetEvents({
            date: this.chosenDay,
            health_professional_id: this.User.specialist.id
          })
          this.loadingEvents = false;
        }
        await this.GetReports();
        await this.GetReportsUnsigned();
        if (this.User.specialist.specialties_info.some(specialty => specialty.type.id === 3)) {
          await this.GetExpiredEvents();
        }

        this.isLoading = false;

        window.emitter.on('protocolsReloadProtocolList', () => {
          if (this.User.specialist.specialties_info.some(specialty => specialty.type.id === 1)) {
            this.GetProtocols({
              specialty_type_id: 1
            })
          }
          if (this.User.specialist.specialties_info.some(specialty => specialty.type.id === 2)) {
            this.GetProtocols({
              specialty_type_id: 2
            })
          }
        })

      } catch {
        this.$toast.error('Ocorreu um erro, tente novamente.', {
          timeout: 3000,
          closeOnClick: true
        });
      }
    }
  },
  async mounted() {
  },
  computed: {
    ...mapGetters({
      Reports: "StateReports",
      Events: "StateEvents",
      ExpiredEvents: "StateExpiredEvents",
      ReportsUnsigned: "StateReportsUnsigned",
      TIProtocols: "StateTIProtocols",
      RDProtocols: "StateRDProtocols",
      User: "StateUser",
      Enable: "StateEnable"
    }),
  },
  methods: {
    ...mapActions(["SetReport"]),
    ...mapActions(["SetProtocol"]),
    ...mapActions(["GetProtocols"]),
    ...mapActions(["GetEvents"]),
    ...mapActions(["GetExpiredEvents"]),
    ...mapActions(["GetReports"]),
    ...mapActions(["GetReportsUnsigned"]),
    ...mapGetters(["isAuthenticated"]),
    ...mapActions(['openModalSignatureRequired']),
    ...mapActions(["GetEnable"]),
    reloadPage() {
      gTrackUpdatePageBtn();
      window.location.reload();
    },
    diffTime(data) {
      const [datePart, timePart] = data.split(' ');
      const [day, month, year] = datePart.split('/').map(Number);
      const [hour, minute] = timePart.split(':').map(Number);

      const dateA = new Date(year, month - 1, day, hour, minute);
      const now = new Date();

      const diffMs = now - dateA;
      const hours = Math.floor(diffMs / 3600000);
      const minutes = Math.floor((diffMs % 3600000) / 60000);

      return hours >= 1 ? `${hours}h:${minutes}m` : `${minutes}m`;
    },
    formatDateTime(dateTime) {
      if (!dateTime) {
        return '';
      }
      const [datePart, timePart] = dateTime.split(' ');
      const [year, month, day] = datePart.split('-');
      return `${day}/${month}/${year} - ${timePart.slice(0, 5)}`;
    },
    formatName(name) {
      let words = name.toLowerCase().split(" ");
      for (let i = 0; i < words.length; i++) {
        let word = words[i];
        words[i] = word.charAt(0).toUpperCase() + word.slice(1);
      }
      return words.join(" ");
    },
    showModalPendency(paramReportUnsigned) {
      this.reportUnsigned = paramReportUnsigned;
      this.isModalPendencyVisible = true;
    },
    closeModalPendency() {
      this.isModalPendencyVisible = false;
    },
    async openAttendanceFormInfo(report) {
      if (!this.Enable) {
        this.$toast.error('Você está indisponível para atender', {
          timeout: 3000,
          closeOnClick: true
        });
      } else {
        await this.SetReport(report);
        this.$router.push({name: 'Report'});
      }
    },
    showModalTriage(protocolUpdate) {
      this.protocolUpdate = protocolUpdate;
      this.isModalTriageVisible = true;
    },
    hideModalTriage() {
      this.protocolUpdate = null;
      this.isModalTriageVisible = false;
    },
    async changeDay(day) {
      const chosenDay = new Date(this.chosenDay);
      if (this.loadingEvents)
        return;
      if (day === 'inc') {
        this.chosenDay = new Date(chosenDay.setDate(chosenDay.getDate() + 1)).toISOString().slice(0, 10);
      } else {
        if (day === 'dec' && this.chosenDay === new Date().toISOString().slice(0, 10)) {
          return;
        }
        this.chosenDay = new Date(chosenDay.setDate(chosenDay.getDate() - 1)).toISOString().slice(0, 10);
      }
      this.loadingEvents = true;
      await this.GetEvents({
        date: this.chosenDay,
        health_professional_id: this.User.specialist.id
      });
      this.loadingEvents = false;
    }
  },
};
</script>

<style scoped>

.btn-back-queue {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  color: #6200EE;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border: 1px solid #6200ee;
  border-radius: 20px;
  padding: 10px;
  width: 300px;
  cursor: pointer;
  margin: 0 auto;
}

.attentive-buttons {
  margin-top: 25px;
  display: flex;
  justify-content: center;
}

.specialist-type-one {
  color: #0d82ad;
}

.specialist-type-two {
  color: #2b8a0e;
}
.specialist-type-three {
  color: #d12da7;
}


.card-expired {
  border-color: #F0506E;
  overflow: hidden;
}

.card-header-expired {
  background-color: #F0506E;
  color: #fff;
}

.btn-open-record {
  background-color: #6200EE;
  border-color: #6200EE;
  color: #fff;
  font-weight: 500;
}

.btn-open-record:hover {
  background-color: #4b00b8;
  border-color: #4b00b8;
  color: #fff;
}

.card-border-pendency {
  border-left: 8px solid rgb(246, 8, 16);
}


.search-bar i {
  margin-right: 10px;
}

.search-bar input[type="search"] {
  flex: 1;
  border: none;
  outline: none;
}

.text-font {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  color: #777777;
}

.text-font-regular {
  font-family: "Roboto", sans-serif;
  font-weight: 100;
  color: #777777;
}

.circle-number {
  width: 30px;
  height: 30px;
  padding: 0;
  background-color: #AE1F38;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
}

.loading {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.centered-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>